import React, { useEffect, useRef, useState } from "react";
import { IP } from "../../../GlobalUtilities/constants/Constants";
import CustomTextField from "../../../GlobalComponents/CustomComponant/CustomTextField";
import DropdownfromDatabaseList from "../../../GlobalComponents/CustomComponant/DropdownfromDatabaseList";
import { Button, Tabs, Tab, Box } from "@mui/material";
import SecureKey from "../../../GlobalUtilities/Securekey/SecureKey";
import CircularProgress from "@mui/material/CircularProgress";
import { API_BASE_URL } from "../../../GlobalUtilities/constants/Constants";

const isMobileOrTablet = () => /Mobi|Android|iPhone|iPad|iPod/.test(navigator.userAgent);
const { generateSignature, verifySignature } = SecureKey();


const MediaCapture = () => {
  
  const [cameraEnabled, setCameraEnabled] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const trainData = [
    { trainno: "12301", trainname: "Rajdhani Express" },
    { trainno: "12296", trainname: "Sanghamitra Express" },
    { trainno: "12841", trainname: "Coromandel Express" },
    { trainno: "12627", trainname: "Karnataka Express" },
    { trainno: "12951", trainname: "Mumbai Rajdhani" }
  ];

  const stationdata = [
    { station: "GKP", stationcode: "Gorakhpur" },
    { station: "BST", stationcode: "Basti" },
    { station: "DMG", stationcode: "Domingargh" },
    { station: "LKO", stationcode: "Lucknow (NR)" },
    { station: "GD", stationcode: "Gonda" }
  ];

  const cleaningtypedata = [
    { cleanning: "Doorway", cleaningcode: "A" },
    { cleanning: "Dustbin", cleaningcode: "B" },
    { cleanning: "Tiolets", cleaningcode: "D" },
    { cleanning: "Gangway", cleaningcode: "C" },
  ];

  const [cleaningtypes, setcleaningtypes] = useState(cleaningtypedata);
  const [cleaningtype, setcleaningtype] = useState("");
  const [coach, setCoach] = useState("");
  const videoRef = useRef(null);
  const mediaStream = useRef(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [error, setError] = useState("");
  const [recording, setRecording] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [username] = useState("amit");
  const [isMobile, setIsMobile] = useState(false);
  const [frontPhoto, setFrontPhoto] = useState(null);
  const [backPhoto, setBackPhoto] = useState(null);
  const [isTakingBackPhoto, setIsTakingBackPhoto] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [geoLocation, setGeoLocation] = useState({ lat: "Unavailable", lon: "Unavailable", area: "Unknown" });

  const [trains, setTrains] = useState(trainData);
  const [train, settrain] = useState("");
  const [gangs, setGangs] = useState([]);
  const [gang, setgang] = useState("");
  const [stations, setStations] = useState(stationdata);
  const [station, setstation] = useState("");
  const [cleaningArea, setClaningArea] = useState("");

  const getAreaFromCoords = async (lat, lon) => {
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`);
      const data = await res.json();
      return data.display_name || "Unknown area";
    } catch (error) {
      return "Area unavailable";
    }
  };

  useEffect(() => {
    return () => {
      stopCamera();
    };
  }, []);

  useEffect(() => {
    const mobileCheck = isMobileOrTablet();
    setIsMobile(mobileCheck);

    if (!mobileCheck) {
      setError("Only front camera will be used on desktop.");
    }

    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async pos => {
        const coords = {
          lat: pos.coords.latitude,
          lon: pos.coords.longitude
        };
        try {
          const areaName = await getAreaFromCoords(coords.lat, coords.lon);
          setGeoLocation({ ...coords, area: areaName });
        } catch (err) {
          setError("Failed to fetch area name.");
        }
      },
      err => {
        if (err.code === 1) setError("Permission denied. Please allow location access.");
        else if (err.code === 2) setError("Position unavailable. Try again.");
        else if (err.code === 3) setError("Location request timed out.");
        else setError("Geolocation error: " + err.message);
      }
    );
  }, []);

  const startCamera = async (front = true) => {
    try {
      const constraints = {
        video: { facingMode: front ? "user" : "environment" },
        audio: true,
      };
      mediaStream.current = await navigator.mediaDevices.getUserMedia(constraints);
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream.current;
      }
    } catch (err) {
      setError("Unable to access camera: " + err.message);
    }
  };

  const stopCamera = () => {
    if (mediaStream.current) {
      mediaStream.current.getTracks().forEach(track => track.stop());
      mediaStream.current = null;
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
    }
  };

  const capturePhoto = async () => {
    setPageLoader(true);
    if (!videoRef.current) return;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    ctx.drawImage(videoRef.current, 0, 0);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, "image/jpeg", 1.0));

    if (!isMobile || isTakingBackPhoto) {
      if (!isMobile) {
        setFrontPhoto(blob);
        setBackPhoto(null);
        mergePhotos();
      } else {
        setBackPhoto(blob);
        mergePhotos();
      }
    } else {
      setFrontPhoto(blob);
      alert("Front photo captured! Now taking back photo.");
      await switchToBackCamera();
      setIsTakingBackPhoto(true);
    }
    setPageLoader(false);
  };

  const switchToBackCamera = async () => {
    stopCamera();
    await startCamera(false);
  };

  const mergePhotos = async () => {
    setPageLoader(true);
    if (!frontPhoto || (isMobile && !backPhoto)) return;
    const frontImg = await createImageBitmap(frontPhoto);
    const backImg = isMobile && backPhoto ? await createImageBitmap(backPhoto) : null;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (isMobile && backImg) {
      canvas.width = frontImg.width;
      canvas.height = frontImg.height + backImg.height;
      ctx.drawImage(frontImg, 0, 0);
      ctx.drawImage(backImg, 0, frontImg.height);
    } else {
      canvas.width = frontImg.width;
      canvas.height = frontImg.height;
      ctx.drawImage(frontImg, 0, 0);
    }

    ctx.fillStyle = "rgba(0,0,0,0.5)";
    ctx.fillRect(0, canvas.height - 70, canvas.width, 70);
    ctx.fillStyle = "white";
    ctx.font = "14px Arial";
    ctx.textAlign = "center";

    const textLines = [
      `User: ${username} | IP: ${IP}`,
      `Time: ${new Date().toLocaleString()}`,
      `Latitude: ${geoLocation.lat}, Longitude: ${geoLocation.lon}`,
      `Area: ${geoLocation.area}`,
    ];
    textLines.forEach((text, i) => {
      ctx.fillText(text, canvas.width / 2, canvas.height - 50 + i * 15);
    });

    canvas.toBlob(async mergedBlob => {
      const url = URL.createObjectURL(mergedBlob);
      setPreviewUrl(url);
      setIsUploading(true);
      await uploadToServer(mergedBlob, "image", ".jpeg");
      // alert("Photo uploaded successfully!");
      stopCamera();
      // setFrontPhoto(null);
      // setBackPhoto(null);
      // setIsTakingBackPhoto(false);
      // setIsUploading(false);
      setTabIndex(0);
      setCameraEnabled(false);
      settrain("");
      setstation("");
      setgang("");
      setFrontPhoto(null);
      setBackPhoto(null);
      setIsTakingBackPhoto(false);
      setIsUploading(false);

    }, "image/jpeg", 0.8);
    setPageLoader(false);
  };





  const captureVideo = async (durationSec) => {
    setPageLoader(true);
    if (!mediaStream.current) return;
    setRecording(true);
    const sessionId = uniqid();
    const frontChunks = [];
    const recorderFront = new MediaRecorder(mediaStream.current);
    recorderFront.ondataavailable = e => frontChunks.push(e.data);
    recorderFront.onstop = async () => {
      const frontBlob = new Blob(frontChunks, { type: "video/webm" });
      if (!isMobile) {
        await uploadToServer(frontBlob, "video", "_front.mov", sessionId);
        //alert("Video uploaded successfully!");
        stopCamera();
        setRecording(false);
        setTabIndex(0);
        setCameraEnabled(false);
        settrain("");
        setstation("");
        setgang("");
        setFrontPhoto(null);
        setBackPhoto(null);
        setIsTakingBackPhoto(false);
        setIsUploading(false);
        return;
      }
      await switchToBackCamera();
      await new Promise(resolve => setTimeout(resolve, 2000));
      const backChunks = [];
      const recorderBack = new MediaRecorder(mediaStream.current);
      recorderBack.ondataavailable = e => backChunks.push(e.data);
      recorderBack.onstop = async () => {
        const backBlob = new Blob(backChunks, { type: "video/webm" });
        await uploadToServer(frontBlob, "video", "_front.mov", sessionId);
        await uploadToServer(backBlob, "video", "_back.mov", sessionId);
        //alert("Videos uploaded successfully!");
        stopCamera();
        setRecording(false);
      };
      recorderBack.start();
      setTimeout(() => recorderBack.stop(), (durationSec * 0.8) * 1000);
    };
    recorderFront.start();
    setTimeout(() => recorderFront.stop(), (durationSec * 0.2) * 1000);

    setPageLoader(false);
  };

  const uniqid = () => `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;




  const uploadToServer = async (blob, type, suffix, sessionId = null) => {
    const formData = new FormData();
    const filename = sessionId ? `${type}_${username}_${sessionId}${suffix}` : `${type}_${username}_${uniqid()}${suffix}`;
    formData.append("file", blob, filename);
    formData.append("username", username);
    formData.append("timestamp", new Date().toLocaleString());
    formData.append("ip", IP);
    formData.append("type", type);
    formData.append("lat", geoLocation.lat);
    formData.append("lon", geoLocation.lon);
    formData.append("area", geoLocation.area);


    formData.append("module", 'OBHS');
    formData.append("gang", gang);
    formData.append("station", station);
    formData.append("train", train);
    formData.append("coach", coach);
    formData.append("cleaningtype", cleaningtype);
    formData.append("cleanarea", cleaningArea);




    //   await fetch("https://ccms.sriyansh.co.in/phpapi/upload/upload.php", { method: "POST", body: formData });
    // };

 //fetch(`${API_BASE_URL}/auditreports`)

    try {
      const response = await fetch(`${API_BASE_URL}/upload/upload.php`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      alert(result.message);
    } catch (error) {
      alert("Upload failed: " + error.message);
    }
  };



















  


  return (
    <Box>
      <Tabs value={tabIndex} onChange={(e, newVal) => setTabIndex(newVal)} centered>
        <Tab label="Entry" />
        {/* <Tab label="Camera" disabled={tabIndex === 0 && (!train || !station)} /> */}
        <Tab label="Camera" disabled={!cameraEnabled} />
      </Tabs>
      {tabIndex === 0 && (
        <Box p={2}>
          {/* Entry Fields */}
          <div className="container">
            <div className="input-group">
              Train Number
              <DropdownfromDatabaseList
                Options={trains}
                option={train}
                setOptionValue={settrain}
                DisplayItem1="trainname"
                DisplayItem2="trainno"
                showKeyInLabel={true} />
            </div>
            {/* <div className="input-group">
              Train Name
              <CustomTextField
                value={train}
                label="Train Name" 
                placeholder="Train Name" 
                maxLength={100} 
                disabled={true} />
            </div> */}
            <div className="input-group">
              Station
              <DropdownfromDatabaseList
                Options={stations}
                option={station}
                setOptionValue={setstation}
                DisplayItem1="stationcode"
                DisplayItem2="station"
                showKeyInLabel={true} />
            </div>
          </div>
          <div className="container">
            <div className="input-group">
              Gang
              <CustomTextField label="Gang Name"
                value={gang}
                onChange={(e) => setgang(e.target.value)}
                placeholder="Gang Name" maxLength={100} />
            </div>
            <div className="input-group">
              Coach Number
              <CustomTextField label="Coach Number"
                value={coach}
                onChange={(e) => setCoach(e.target.value)}
                placeholder="Coach Number" maxLength={3} />
            </div>
          </div>

          <div className="container">

            <div className="input-group">
              Cleaning Type
              <DropdownfromDatabaseList
                Options={cleaningtypes}
                option={cleaningtype}
                setOptionValue={setcleaningtype}
                DisplayItem1="cleanning"
                DisplayItem2="cleaningcode"
                showKeyInLabel={false} />
            </div>

            <div className="input-group">
              Cleaning Area
              <CustomTextField label="Cleaning Area"
                value={cleaningArea}
                onChange={(e) => setClaningArea(e.target.value)}
                placeholder="Cleaning Area" maxLength={3} />
            </div>

          </div>


          <Box mt={3} display="flex" justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                if (train && station && cleaningtype) {
                  //alert(generateSignature('amitsrivastava'))

                  setCameraEnabled(true);
                  setTabIndex(1);
                } else {
                  alert("Please fill all required fields before proceeding to Camera.");
                }
              }}
            >
              Go to Camera
            </Button>
          </Box>





        </Box>
      )}
      {tabIndex === 1 && (


        <Box p={2}>

          {/* Camera UI */}
          <div className="flex items-center justify-center">
            <div className="p-4 flex flex-col items-center space-y-4">


              <div style={{ width: "240px", height: "360px" }}>
                <video ref={videoRef} autoPlay playsInline muted style={{ width: "240px", height: "360px", objectFit: "cover" }} />
              </div>




              <div className="flex items-center justify-center min-h-screen   mt-8 sm:mt-0">

                {pageLoader && (
                  <div className="loaderContainer">
                    <CircularProgress sx={{ color: '#ff5722' }} />
                  </div>
                )}
                <div className="flex flex-wrap justify-center gap-2 mt-4">

                  <Button
                    variant="contained"
                    sx={{ px: 2, py: 1, mr: 2, mt: 2, minWidth: "200px", backgroundColor: "#4CAF50" }}
                    onClick={() => {
                      if (!isMobile) {
                        alert("Only Mobile devices can use this option.");
                        return;
                      }
                      startCamera();
                    }}
                    disabled={recording || isUploading || !isMobile}
                  >Start Camera
                  </Button>

                  <Button
                    variant="contained"
                    sx={{ px: 2, py: 1, mr: 2, mt: 2, minWidth: "200px" }}
                    onClick={() => {
                      if (!isMobile) {
                        alert("Only Mobile devices can use this option.");
                        return;
                      }
                      capturePhoto();
                    }}
                    disabled={recording || isUploading || !isMobile}
                  >
                    {isMobile && isTakingBackPhoto ? "Take Back Photo" : "Take Photo"}
                  </Button>




                  {[10, 20, 30].map((sec) => (
                    <Button
                      variant="contained"
                      color="secondary"
                      sx={{ px: 2, py: 1, mr: 2, mt: 2, minWidth: "200px" }}
                      key={sec}
                      onClick={() => {
                        if (!isMobile) {
                          alert("Only Mobile devices can use this option.");
                          return;
                        }
                        captureVideo(sec);
                      }}
                      disabled={recording || isUploading || !isMobile}
                    >
                      {recording ? "Recording..." : `Record ${sec}s Video`}
                    </Button>
                  ))}

                </div>

                {error && <p className="text-red-500 text-center">{error}</p>}
              </div>

            </div>

          </div>
        </Box>

      )}
    </Box>
  );
};

export default MediaCapture;